export default __webpack_public_path__ + "static/media/bombo.88243790.svg";